<template>
    <component
        :is="element"
        v-bind="attributes"
        class="cta-cards-list-card"
        :class="{
            'cta-cards-list-card--theme-color': featureFlag('cta-cards-list')
        }"
    >
        <h4 class="cta-cards-list-card__title">
            <slot name="title" />
        </h4>

        <div class="cta-cards-list-card__text">
            <slot />
        </div>

        <div class="cta-cards-list-card__image">
            <slot name="image" />
        </div>
    </component>
</template>

<script setup>
const { checkIsExternal } = useUri();
const { featureFlag } = useMultisite();

const props = defineProps({
    uri: {
        type: String,
        required: false,
        default: null
    }
});

const element = computed(() => {
    if (!props.uri) {
        return 'article';
    }
    if (checkIsExternal(props.uri)) {
        return 'a';
    }
    return resolveComponent('NuxtLink');
});

const attributes = computed(() => {
    if (!props.uri) {
        return null;
    }
    if (checkIsExternal(props.uri)) {
        return {
            href: props.uri,
            target: '_blank',
            rel: 'noopener'
        };
    }
    return {
        to: props.uri
    };
});
</script>

<style lang="less">
.cta-cards-list-card {
    padding: 1.25rem;
    min-height: 10.5625rem;
    display: flex;
    flex-direction: column;
    gap: .25rem;

    border-radius: var(--borderRadius-xs);
    background: var(--color-secondary);

    @media @q-md-min {
        padding: var(--spacing-lg);
        width: 16.75rem;
        min-height: 19.25rem;
        gap: var(--spacing-xs);
    }
}

a.cta-cards-list-card {
    text-decoration: none;
}

.cta-cards-list-card__title {
    .typography-h4();

    color: var(--color-primary-dark);
}

.cta-cards-list-card__text {
    .typography-text();

    color: var(--color-primary-dark);
    opacity: .6;
    transition: opacity var(--transition-fast);

    .cta-cards-list-card[href]:active &,
    .cta-cards-list-card[href]:hover & {
        opacity: 1;
    }
}

.cta-cards-list-card__image {
    margin-top: auto;
    width: 2.5rem;
    transform: scale(1);
    transition: transform var(--transition-fast);

    .cta-cards-list-card[href]:active &,
    .cta-cards-list-card[href]:hover & {
        transform: scale(1.125);
    }

    @media @q-md-min {
        width: 4.875rem;
    }
}
</style>
